import React from 'react'
import { Route, Switch } from 'react-router-dom'
import CreateParaphrase from '../paraphrase/CreateParaphrase'

const Trial = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Route path={`${match.url}/`} component={CreateParaphrase} />
    </Switch>
  </div>
)
export default Trial
